export const noop = () => {
  // no operation
};

export const formatDate = (dateString: string) => {
  const date = new Date(dateString);

  if (Number.isNaN(date.getTime())) {
    return "";
  }

  return new Intl.DateTimeFormat("ru-Ru", {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
  })
    .format(date)
    .replace(" г.", "");
};

export const makeSortByMetaDate = (
  field: "dateModified" | "dateCreated",
  order: "asc" | "desc" = "desc",
) => {
  return (a: any, b: any): number => {
    const dateA = a?.meta?.[field] ? new Date(a.meta[field]) : null;
    const dateB = b?.meta?.[field] ? new Date(b.meta[field]) : null;

    if (!dateA && !dateB) return 0;
    if (!dateA) return 1;
    if (!dateB) return -1;

    const diff = dateB.getTime() - dateA.getTime();

    return order === "desc" ? diff : -diff;
  };
};
